import type { FC } from 'react';
import { Button } from '@patternfly/react-core/dist/dynamic/components/Button';
import { ButtonProps } from '@patternfly/react-core/dist/dynamic/components/Button';
import { PauseIcon } from '@patternfly/react-icons/dist/dynamic/icons/pause-icon';
import { PlayIcon } from '@patternfly/react-icons/dist/dynamic/icons/play-icon';
import { css } from '@patternfly/react-styles';
import { useTranslation } from 'react-i18next';

export interface TogglePlayProps {
  active: boolean;
  className?: string;
  onClick: ButtonProps['onClick'];
}

export const TogglePlay: FC<TogglePlayProps> = ({ active, className, onClick }) => {
  const { t } = useTranslation();

  return (
    <Button
      icon={active ? <PauseIcon /> : <PlayIcon />}
      variant="plain"
      className={css(
        'co-toggle-play',
        active ? 'co-toggle-play--active' : 'co-toggle-play--inactive',
        className,
      )}
      onClick={onClick}
      aria-label={active ? t('public~Pause event streaming') : t('public~Start streaming events')}
    />
  );
};
